/**
 * Scoring config (v2)
 *
 * We keep 6 core modes as the base and improve accuracy via:
 * - question weights (foundation, defaults to 1)
 * - deterministic tie breaking
 * - confidence based on margin between top scores
 */

export const scoringConfig = {
  version: 2,
  // If a question ID is not present here, weight defaults to 1.
  questionWeights: {
    // Higher weight for questions that are more diagnostic in practice:
    // - under pressure or uncertainty
    // - decision making tradeoffs
    // - risk posture
    3: 1.25,  // project gets messy
    6: 1.2,   // hard decision
    8: 1.15,  // risk approach
    10: 1.1,  // 90 day planning
    15: 1.3,  // under real pressure
  },
  // Deterministic tie breaker order (used only when scores are tied).
  tieBreakOrder: ['visionary', 'executor', 'innovator', 'strategist', 'analyst', 'relationshipBuilder'],
};

